import React, {Component} from 'react';
import {Switch, Route, Link} from 'react-router-dom';
import {Helmet} from 'react-helmet';
import CONFIG from './../../SYSTEM/Config.js'
import {Request} from "./../../SYSTEM/Request"

/// REDUX ///
import * as ReduxActions from './../../REDUX/functions.js';
import {bindActionCreators} from 'redux';
import {connect} from 'react-redux';

import InnerLoader from './../../APP/COMPONENTS/InnerLoader';
import * as helpers from "./../../APP/HELPERS/functions"

function mapStateToProps(state) {
    return {
        USER: state.USER
    };
}

function mapDispatchToProps(dispatch) {
    return bindActionCreators(ReduxActions, dispatch)
}

class CommentsModalWindow extends Component {

    /// CONSTRUCTOR ///
    constructor(props) {
        super(props);

        this.state = {
            LOADED: false,
            COMMENTS: false,
            PRODUCT: props.PRODUCT,
            PERCENTS: false,
            DATE_TILL: props.DATE_TILL,
            DATE_FROM: props.DATE_FROM
        };
    }

    componentDidMount() {
        this.fetchRates()
    }


    componentDidUpdate(prevProps, prevState, snapshot) {
    }

    fetchRates = async () => {

        if (this.props.PRODUCT) {
            let SEND_DATA = {
                action: 'supplierProductRate',
                supplier_apikey: this.props.USER.supplier_apikey,
                id: this.props.PRODUCT.id,
                date_till: this.state.DATE_TILL,
                date_from: this.state.DATE_FROM
            };
            try {
                let data = await Request(SEND_DATA, CONFIG.API_GATE);
                if (data !== false) {
                    this.setState({COMMENTS: data.comments, PERCENTS: data.percents, LOADED: true});
                } else {
                    this.setState({LOADED: true});
                }
            } catch (error) {
            }
        }
    }

    renderLine = (percent) => {
        if (percent !== 0) {
            return (
                "backgroundColor: #FFC961, borderLeft:" + " " + percent + " " + "solid red"
            )
        } else {
            return (
                "#A1A7BD"
            )
        }

    }

    renderRating = () => {
        console.log()
        if (this.state.PERCENTS) {
            return (
                <div className="rating_lines_holder">
                    <div className="line_and_number">
                        <div className="number_of_line">5</div>
                        <div className="rating_lines">
                            <div style={{width: this.state.PERCENTS[5] + "%"}} className="sub_line"></div>
                        </div>
                    </div>
                    <div className="line_and_number">
                        <div className="number_of_line">4</div>
                        <div className="rating_lines">
                            <div style={{width: this.state.PERCENTS[4] + "%"}} className="sub_line"></div>
                        </div>
                    </div>
                    <div className="line_and_number">
                        <div className="number_of_line">3</div>
                        <div className="rating_lines">
                            <div style={{width: this.state.PERCENTS[3] + "%"}} className="sub_line"></div>
                        </div>
                    </div>
                    <div className="line_and_number">
                        <div className="number_of_line">2</div>
                        <div className="rating_lines">
                            <div style={{width: this.state.PERCENTS[2] + "%"}} className="sub_line"></div>
                        </div>
                    </div>
                    <div className="line_and_number">
                        <div className="number_of_line">1</div>
                        <div className="rating_lines">
                            <div style={{width: this.state.PERCENTS[1] + "%"}} className="sub_line"></div>
                        </div>
                    </div>
                </div>
            )
        }
    }

    renderComments = () => {
        let COMMENTS = []
        if (this.state.COMMENTS) {
            for (let i = 0; i < this.state.COMMENTS.length; i++) {
                let COMMENT = this.state.COMMENTS[i]
                COMMENTS.push(
                    <div className="name_and_comment_holder" key={i}>
                        <div className="name_and_date-holder">
                            <div className="name_in_rates">{COMMENT.name}</div>
                            <div className="date_in_rates">{COMMENT.date}</div>
                        </div>
                        <div className="comment_in_rates">{COMMENT.comment}</div>
                    </div>
                )
            }
        }
        return (COMMENTS)
    }


    render() {
        return (
            <div className="modal-content_rates">
                <img className="blue_cross" src="/system_images/blue_cross.png" onClick={()=> this.props.openCommentModal(false)}/>
                <div className="rating_comments_holder">
                    <div className="title_and_rating_holder">
                        <div className="product_title_in_rating_modal">{this.state.PRODUCT.title}</div>
                        <div className="rate_in_modal"><img src="/system_images/star.png" /> {this.state.PRODUCT.rate}</div>
                    </div>
                    {this.renderRating()}
                    <div className="render_comments_holder">
                        {this.renderComments()}
                    </div>
                </div>
            </div>
        );
    }

}

export default connect(
    mapStateToProps, mapDispatchToProps
)(CommentsModalWindow);